import { useCallback, useState } from "react";
import { useQuery } from "@apollo/react-hooks";
import { GET_SPENDING_DETAILS } from "../api/analytics";
import getTimezoneOffset from "../utils/timezone";

const PAGE_SIZE = 30;

const timezoneOffset = getTimezoneOffset();

export default (filter, { months, startDate, endDate } = {}) => {
  const [loadMoreDisabled, setLoadMoreDisabled] = useState(false);

  const { data, loading, error, fetchMore } = useQuery(GET_SPENDING_DETAILS, {
    variables: {
      categoryId: filter && filter.categoryId,
      note: filter && filter.note,
      currencyId: filter && filter.currencyId,
      categoryType: filter && filter.categoryType,
      months,
      startDate,
      endDate,
      timezoneOffset,
      offset: 0,
      limit: PAGE_SIZE,
    },
    fetchPolicy: "cache-and-network",
    notifyOnNetworkStatusChange: true,
    skip: !filter,
    onCompleted(result) {
      if (result.spendings.length < PAGE_SIZE) {
        setLoadMoreDisabled(true);
      }
    },
  });

  const loadMore = useCallback(() => {
    if (loadMoreDisabled || !data) {
      return;
    }

    fetchMore({
      variables: { offset: data.spendings.length },
      updateQuery: (prev, { fetchMoreResult }) => {
        if (!fetchMoreResult) return prev;

        if (fetchMoreResult.spendings.length < PAGE_SIZE) {
          setLoadMoreDisabled(true);
        }

        return {
          ...prev,
          spendings: [...prev.spendings, ...fetchMoreResult.spendings],
        };
      },
    });
  }, [fetchMore, loadMoreDisabled, data]);

  return {
    loading,
    error,
    spendings: data && data.spendings,
    loadMore,
    canLoadMore: !loadMoreDisabled,
  };
};
